var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "p-20 justify-content-center d-flex" }, [
      _c("div", { staticClass: "content-container-mobile" }, [
        _c(
          "div",
          { staticClass: "style-group" },
          [_c("style-description"), _vm._v(" "), _c("style-selector")],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }